import CryptoJS from 'crypto-js';

import { encrypt } from './common/aes';

const endpoint = process.env.VUE_APP_DDPAY_HOST;

// const endpoint = 'https://sso-dev.citycoins.cc/apps/qpoints/authorize'; // 開發環境
// const endpoint = 'https://sso-staging.citycoins.cc/apps/qpoints/authorize';
const vendorId = 'smc';
const merchantId = 'yunlin';
const platformId = 'yunlin-app';
const projectId = 'yunlinv2';
const appId = process.env.VUE_APP_DDPAY_APP_ID;
const appSecret = process.env.VUE_APP_DDPAY_APP_SECRET;

const ecCoinUrl = process.env.VUE_APP_EC_COIN_URL
// const ecHost = process.env.VUE_APP_EC_HOST
const ecvendorId = 'yunlin';
const ecprojectId = 'yunlin-v2';
const ecappId = process.env.VUE_APP_EC_APP_ID;
const ecappSecret =  process.env.VUE_APP_EC_APP_SECRET;
const ecshortApiId = process.env.VUE_APP_EC_SHORT_API_ID;

// https://web-dev.ddpay.ai/apis/auth-redirect?D01=staging&D02=D_1LJd7kjE4&D03=KOAZMMQG&partner- code=smc&merchant-id=yunlin>
const userToken = "";
const replyToken = "";
const shortApiId = process.env.VUE_APP_DDPAY_SHORT_API_ID;

function addQueryToUrl(url, newQueryParams) {
  // 使用 URL 對象來解析和處理 URL
  const parsedUrl = new URL(url);
  
  // 遍歷新的 query 參數並加入到當前 URL 的 searchParams 中
  for (const key in newQueryParams) {
    if (key in newQueryParams) {
      parsedUrl.searchParams.set(key, newQueryParams[key]);
    }
  }

  // 返回修改過後的完整 URL 字串
  return parsedUrl.toString();
}

const generateNextUrl = (nextUrl) => {
  const parsedUrl = new URL(nextUrl);
  const urlParams = new URLSearchParams(parsedUrl.search);
  const d01 = urlParams.get('D01') || 'staging';
  const shopId = urlParams.get('D02') || 'D_ZbveKM6Xo';
  const terminalId = urlParams.get('D03') || 'KEWRNBJX';

  return addQueryToUrl(getNextDomain(), {
    'D01': d01,
    'D02': shopId,
    'D03': terminalId,
    'partner-code': vendorId,
    'merchant-id': merchantId
  });
}
const generateNextUrl09 = (nextUrl) => {
  const parsedUrl = new URL(nextUrl);
  const urlParams = new URLSearchParams(parsedUrl.search);
  let ecHostUrl = urlParams.get('D06')
  const d01 = urlParams.get('D01') || 'staging';
  const shopId = urlParams.get('D02') || 'D_ZbveKM6Xo';
  const terminalId = urlParams.get('D03') || 'KEWRNBJX';
  //const card_id = urlParams.get('card_id') || '';
  console.log('ecHostUrl',ecHostUrl)
  //ecHostUrl='http://localhost:5173/claw/?card_id=E831CD246FDC'
  return addQueryToUrl(ecHostUrl, {
    'D01': d01,
    'D02': shopId,
    'D03': terminalId,
    'partner-code': vendorId,
    'merchant-id': merchantId,
    'openExternalBrowser':1
   // 'card_id': card_id
  });
}
const validateUrl = (url) => {
  const parsedUrl = new URL(url);
  const urlParams = new URLSearchParams(parsedUrl.search);
  const d01 = urlParams.get('D01');
  const shopId = urlParams.get('D02');
  const terminalId = urlParams.get('D03');

  if (!d01 || !shopId || !terminalId) {
    return false;
  }

  return true;
}

const getNextDomain = () => {
  return process.env.VUE_APP_DDPAY_URL;
}

const usePay = () => {
  const getRedirectUrl = ({
    userId = '',
    userName = '',
    userPhone = '',
    userEmail = '',
    nextUrl = '',
  } = {}) => {
    if (!userId) {
      throw new Error('userId is required');
    }
    if (!userName) {
      throw new Error('userName is required');
    }
    if (!userPhone) {
      throw new Error('userPhone is required');
    }
    // if (!userEmail) {
    //   throw new Error('userEmail is required');
    // }
    if (!nextUrl) {
      throw new Error('nextUrl is required');
    }

    const isPass = validateUrl(nextUrl)
    if (!isPass) {
      throw new Error('nextUrl is invalid');
    }

    const parsedUrl = new URL(nextUrl);
    // 取得 pathname 部分（不包含 query string）
    const pathSegments = parsedUrl.pathname.split('/').filter(Boolean); // filter(Boolean) 是為了去掉空字串
    // 最後一段就是問號前的那段
    const lastSegment = pathSegments[pathSegments.length - 1];
    if(lastSegment === '09' ){
      return getClawRedirectUrl({
          userId: userId,
          userName: userName,
          userPhone: userPhone,
          userEmail: userEmail,
          nextUrl: nextUrl,
        }
      )
    }

    const customData = {
      "project_id": projectId,
      "identity_pool_id": "",
      "identity_id": userId, // SSO模組取得的userId
      "invite_code": "",
      "user_token": "", // 保留欄位
      "user_name": userName, 
      "user_phone": userPhone,
      "user_email": userEmail,
    };
    
    const payloadStr = JSON.stringify(customData);
    const encryptedData = encrypt(payloadStr, appSecret);
    const timestamp = new Date().getTime();
    const rawData = timestamp + vendorId + platformId + appId + userId + userToken + replyToken + shortApiId;
    const computedSign = CryptoJS.HmacSHA256(rawData, appSecret).toString(CryptoJS.enc.Hex);
    
    const query = {
      'x-3rd-timestamp': timestamp,
      'x-3rd-vendor-id': vendorId,
      'x-3rd-platform-id': platformId,
      'x-3rd-app-id': appId,
      'x-3rd-user-id': userId,
      'x-3rd-custom-data': encryptedData,
      'x-3rd-token': replyToken,
      'x-3rd-frame-url': '',
      'x-3rd-signature': computedSign,
      'x-3rd-next-url': generateNextUrl(nextUrl),
    };

    const queryString = new URLSearchParams(query).toString();
    return `${endpoint}?${queryString}`;
  }
  const getClawRedirectUrl = ({
    userId = '',
    userName = '',
    userPhone = '',
    // userEmail = '',
     nextUrl = '',
  } = {})=>{
    const customData = {
      project_id: ecprojectId,
      identity_pool_id: '',
      identity_id: userId,
      invite_code: '',
      user_token: '',
      user_name: userName,
      user_phone: userPhone
    };
    console.log('customData',customData)
    const payloadStr = JSON.stringify(customData);
    const encryptedData = encrypt(payloadStr, ecappSecret);
    const timestamp = new Date().getTime();
    const rawData = timestamp + ecvendorId + platformId + ecappId + userId + userToken + replyToken + ecshortApiId;
    const computedSign = CryptoJS.HmacSHA256(rawData, ecappSecret).toString(CryptoJS.enc.Hex);
    
    console.log('ecHost',generateNextUrl09(nextUrl))
    const query = {
      'x-3rd-timestamp': timestamp,
      'x-3rd-vendor-id': ecvendorId,
      'x-3rd-platform-id': platformId,
      'x-3rd-app-id': ecappId,
      'x-3rd-user-id': userId,
      'x-3rd-custom-data': encryptedData,
      'x-3rd-token': replyToken,
      'x-3rd-frame-url': '',
      'x-3rd-signature': computedSign,
      'x-3rd-next-url': generateNextUrl09(nextUrl),
    };

    const queryString = new URLSearchParams(query).toString();
    console.log('clawurl', `${ecCoinUrl}?${queryString}`)
    return `${ecCoinUrl}?${queryString}`;
  }
  return {
    getRedirectUrl
  }
}

export default usePay;
